import * as React from 'react';
import { findTableId, type IRoomProps, TableShape, type TableDef } from './TableShape';

import trnava from 'src/assets/tables/arms/trnava.svg?url';
import spis from 'src/assets/tables/arms/spis.svg?url';
import dubravka from 'src/assets/tables/arms/dubravka.svg?url';
import petrzalka from 'src/assets/tables/arms/petrzalka.svg?url';
import banskaStiavnica from 'src/assets/tables/arms/banska-stiavnica.svg?url';
import raca from 'src/assets/tables/arms/raca.svg?url';
import orava from 'src/assets/tables/arms/orava.svg?url';
import samorin from 'src/assets/tables/arms/samorin.svg?url';

const TABLE_WIDTH = 148;
const TABLE_HEIGHT = 92;
const COL_X = [125, 279, 433, 587];
const ROW_Y = [140, 242];

const table = (id: number, col: number, row: number, image: string, label: string): TableDef => ({
  id,
  x: COL_X[col],
  y: ROW_Y[row],
  width: TABLE_WIDTH,
  height: TABLE_HEIGHT,
  image,
  label,
  variant: 'emblem',
});

// Ids are Odoo room.room ids; images are the places' coats of arms (see assets/tables/arms/CREDITS.md)
const TABLES: TableDef[] = [
  table(15, 0, 0, trnava, 'Trnava'),
  table(16, 1, 0, spis, 'Spiš'),
  table(17, 2, 0, dubravka, 'Dúbravka'),
  table(14, 3, 0, petrzalka, 'Petržalka'),
  table(18, 0, 1, banskaStiavnica, 'Banská\nŠtiavnica'),
  table(19, 1, 1, raca, 'Rača'),
  table(20, 2, 1, orava, 'Orava'),
  table(21, 3, 1, samorin, 'Šamorín'),
];

// Door opening in the left wall, hinged at its top end
const DOOR_TOP = 200;
const DOOR_BOTTOM = 280;
const DOOR_WIDTH = DOOR_BOTTOM - DOOR_TOP;

const CABINETS = [
  { x: 159, width: 125 },
  { x: 289, width: 125 },
];
const CABINET_DEPTH = 52;

// Magnetic board on the bottom wall
const BOARD = { x: 202, width: 344, depth: 6 };

// Windows along the whole right wall
const WINDOW_PANES = [10, 122, 234, 346];
const WINDOW_PANE_HEIGHT = 104;
const WINDOW_DEPTH = 6;

const SpotSeventhFloor: React.FC<IRoomProps> = ({ onTableClick, activeTableId, filledTables = {}, standingTableIds }) => {
  const handleClick = (e: React.MouseEvent) => {
    const tableId = findTableId(e.target);
    if (tableId != null) onTableClick?.(tableId);
  };

  return (
    <svg className="room" onClick={handleClick} viewBox="0 0 760 460" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="2.5" width="755" height="455" className="room-floor" />
      <path
        d={`M2.5 ${DOOR_TOP}V2.5H757.5V457.5H2.5V${DOOR_BOTTOM}`}
        className="room-wall"
        style={{ fill: 'none' }}
      />
      <path
        d={`M2.5 ${DOOR_TOP}H${2.5 + DOOR_WIDTH}A${DOOR_WIDTH} ${DOOR_WIDTH} 0 0 1 2.5 ${DOOR_BOTTOM}Z`}
        className="room-wall"
      />
      {CABINETS.map(c => (
        <rect key={c.x} x={c.x} y="2.5" width={c.width} height={CABINET_DEPTH} className="room-wall" />
      ))}
      <rect x={BOARD.x} y={457.5 - BOARD.depth} width={BOARD.width} height={BOARD.depth} className="room-wall" />
      {WINDOW_PANES.map(y => (
        <rect
          key={y}
          x={757.5 - WINDOW_DEPTH}
          y={y}
          width={WINDOW_DEPTH}
          height={WINDOW_PANE_HEIGHT}
          className="room-wall"
        />
      ))}
      {TABLES.map(t => (
        <TableShape
          key={t.id}
          data-active={activeTableId === t.id}
          data-filled={!!filledTables[t.id]}
          data-empty={!filledTables[t.id]}
          user={filledTables[t.id]?.user}
          standing={standingTableIds?.has(t.id)}
          {...t}
        />
      ))}
    </svg>
  );
};

export default SpotSeventhFloor;
